import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService implements OnDestroy {
  protected _data = new Map<string, any>();
  dataVar: Subject<Map<string, any>> = new Subject<Map<string, any>>();
  dataVar$ = this.dataVar.asObservable();
  subscription = this.dataVar.subscribe();

  get data() {
    return this._data;
  }

  set data(data: Map<string, any>) {
    this._data = data;
  }

  setDataVar = (key: string, value: any) => {
    // let newMap:Map<string, any> = new Map<string, any>();;
    // Object.assign(newMap, this._data);
    // newMap.set(key, value);
    this._data.set(key, value);
    this.dataVar.next(this._data);
  };

  getValueByKey(key: string): any {
    if (this._data.has(key)) {
      return this._data.get(key);
    }
    return null;
  }

  setValue(key: string, value: any) {
    this._data.set(key, value);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
